import React from 'react';
import PropTypes from 'prop-types';
import { parseCouponDate } from 'config/utils';
import CouponMessage from 'components/CouponMessage';
import ExclusiveMetro from 'assets/images/products/product-metro.png';
import './style.scss';
import BarcodeEcommerceItem from 'components/BarcodeEcommerceItem';


const EcommerceFormatItem = ({ 
    coupon = {},
     controlTerms = null, 
     hasSession = true, 
     showExclusivePic = false ,
     handleEcomerceFormatProcessChange=null,
     handleEcomerceFormatValueCopy=null,
     value=false
    }) => {

   
    const showingLegal = (event, coupon) => {
        controlTerms && controlTerms(event, coupon);
    }
    const handleEcomerceProcessChange=()=>{
        handleEcomerceFormatProcessChange(); //popup button
    }
    const handleEcomerceValueCopy=(valueBarcode)=>{
        handleEcomerceFormatValueCopy(valueBarcode); //selected barcode

    }


    return (
        <>
        <div className="slide">
            <div className={"coupon"}>
                <div className="row">
                    <div className="col-5">
                        <p className="image">
                            <img src={showExclusivePic ? ExclusiveMetro : coupon.image} alt={coupon.nameCoupon} />
                        </p>
                    </div>
                    <div className="col-7">
                        <div className="row">
                            <div className="col-12 info">
                                <CouponMessage data={coupon} showPersonalizado={false}/>
                            </div >
                        </div>
                        <BarcodeEcommerceItem 
                         barcodeEcommerce={coupon.barCode} 
                         handleEcomerceItemProcessChange={handleEcomerceProcessChange}
                         handleEcomerceItemValueCopy={handleEcomerceValueCopy}
                         valueBarcode={value}/>
                               
                    </div>
                   

                   
                    
                    <div className="col-12">
                        <p className="valid">Vence {parseCouponDate(coupon.vencimiento)}</p>
                        { hasSession &&
                        <p className="legal">
                            <a href="#" onClick={(event) => showingLegal(event, coupon)}>Ver legal</a>
                        </p>
                        }
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}

EcommerceFormatItem.propTypes = {
    coupon: PropTypes.object,
    controlTerms: PropTypes.func,
    hasSession: PropTypes.bool, 
    showExclusivePic: PropTypes.bool,
    handleEcomerceFormatProcessChange:PropTypes.func,
    handleEcomerceFormatValueCopy:PropTypes.func,
    value:PropTypes.string
};

export default EcommerceFormatItem;